// Chakra imports
import { Flex, Grid, useColorModeValue, Box, Input, Button, Text, Heading } from "@chakra-ui/react";
import avatar4 from "assets/img/avatars/avatar4.png";
import { useDispatch, useSelector } from "react-redux";
import ProfileBgImage from "assets/img/backarrowlong.jpg";
import React, { useState, useEffect } from "react";
import Conversations from "./components/Conversations";
import { useHistory } from 'react-router-dom';
import Header from "./components/Header";
import ProfileInformation from "./components/ProfileInformation";
import { getUserProfile } from "state/actions/userActions";
import { changePassword } from "state/actions/authActions";
import GradientButton from "components/Buttons/GradientButton";
import { LOGOUT } from "state/actions/types";
import ChangePasswordCard from "./components/ChangePasswordCard";

function Profile() {
  // Chakra color mode
  const textColor = useColorModeValue("gray.700", "white");
  const bgProfile = useColorModeValue(
    "hsla(0,0%,100%,.8)",
    "linear-gradient(112.83deg, rgba(255, 255, 255, 0.21) 0%, rgba(255, 255, 255, 0) 110.84%)"
  );

  const [isLoading, setIsLoading] = useState(true);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const dispatch = useDispatch();
  const history = useHistory();
  const { userProfile } = useSelector((state) => state.users);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");

    dispatch({ type: LOGOUT });

    history.push("/auth/signin");
  };

  useEffect(() => {
    dispatch(getUserProfile()).then(() => setIsLoading(false));
  }, []);

  const handlePasswordChange = async (currentPassword, newPassword) => {
    const response = await dispatch(changePassword(userProfile.email, currentPassword, newPassword));
    if (response.success) {
      handleLogout();
    }
    return response;
  };

  return (
    <Flex direction="column">
      <Header
        backgroundHeader={ProfileBgImage}
        backgroundProfile={bgProfile}
        name={`${userProfile?.first_name} ${userProfile?.last_name}` || userProfile?.username || "Unknown User"}
        email={userProfile?.email || ""}
        tabs={[]}
        isLoading={isLoading}
      />
      <Grid templateColumns={{ sm: "1fr", xl: "repeat(3, 1fr)" }} gap="22px">
        <ProfileInformation
          title={"Profile Information"}
          description={`Admin ${userProfile?.username || ""} is currently ${userProfile?.status || "Active"}.`}
          name={`${userProfile?.first_name} ${userProfile?.last_name}` || userProfile?.username || "Unknown User"}
          mobile={userProfile?.phone_number || ""}
          email={userProfile?.email || ""}
          location={userProfile?.village && userProfile?.district ? `${userProfile.village}, ${userProfile.district}` : userProfile?.district || userProfile?.village || ""}
          isLoading={isLoading}
        />

        {/* Change Password Box */}
        <ChangePasswordCard
          isLoading={isLoading}
          onPasswordChange={handlePasswordChange}
        />
      </Grid>
    </Flex>
  );
}

export default Profile;
